// import userData from "./data/data.json";
// const {user} = userData;
// console.log(user);
// const {products} = userData;
// console.log(products);

import {user, products, favoriteProducts} from "./data/data.json";
console.log(user);
console.log(products);
console.log(favoriteProducts);
